import { Badge } from '@hopin-team/ui-badge';
import { Butticon } from '@hopin-team/ui-butticon';
import { Button } from '@hopin-team/ui-button';
import { Flex } from '@hopin-team/ui-flex';
import { getFromTheme } from '@hopin-team/ui-helper-deep-branding';
import { rem } from 'polished';
import styled from 'styled-components';

export const BookedSeatContainer = styled(Flex)`
  width: 100%;
  height: ${rem(30)};
`;

export const CancelSeatButton = styled(Butticon)`
  height: ${rem(30)};
  width: ${rem(30)};
`;

export const PressedButton = styled(Button)`
  background-color: ${({ theme }) => getFromTheme('COLOR.BLUE.200', theme)};
`;

export const FullWidthBadge = styled(Badge)`
  flex-grow: 1;
`;
